export default __webpack_public_path__ + "static/GT-America-Standard-Regular-a4c41e02019f85b1f992f253ff187285.ttf";